import { uniq } from "lodash";
import {
  MapFilterActionsEnum,
  MapFiltersAction,
  MapCybersecurityFiltersState,
} from "./types";

const initialState: MapCybersecurityFiltersState = {
  suggestions: [],
  activeSuggestions: [],
  services: [],
  company_size: [],
  registration_date__gte: undefined,
  registration_date__lte: undefined,
  company_type: [], // "Представництво", "Українська"
  edrpou: [],
  region: [],
  lat_border__range: undefined,
  lon_border__range: undefined,
  other_services: [],
  certifications: undefined,
  service_category: [],
};

export default function mapFiltersReducer(
  state = initialState,
  action: MapFiltersAction & any
) {
  switch (action.type) {
    case MapFilterActionsEnum.SET_CYBERSECURITY_SERVICE:
      return state.services.includes(action.payload)
        ? {
            ...state,
            services: state.services.filter((item) => item !== action.payload),
          }
        : {
            ...state,
            services: [...state.services, action.payload],
          };

    case MapFilterActionsEnum.CLEAN_CYBERSECURITY_SERVICE:
      return { ...state, services: [] };

    case MapFilterActionsEnum.SET_CYBERSECURITY_SERVICE_CATEGORY:
      return state.service_category.includes(action.payload)
        ? {
            ...state,
            service_category: state.service_category.filter(
              (item) => item !== action.payload
            ),
          }
        : {
            ...state,
            service_category: [...state.service_category, action.payload],
          };

    case MapFilterActionsEnum.CLEAN_CYBERSECURITY_SERVICE_CATEGORY:
      return { ...state, service_category: [] };

    case MapFilterActionsEnum.SET_CYBERSECURITY_COMPANY_SIZE:
      return state.company_size.includes(action.payload)
        ? {
            ...state,
            company_size: state.company_size.filter(
              (item) => item !== action.payload
            ),
          }
        : {
            ...state,
            company_size: [...state.company_size, action.payload],
          };
    case MapFilterActionsEnum.CLEAN_CYBERSECURITY_COMPANY_SIZE:
      return { ...state, company_size: [] };
    case MapFilterActionsEnum.SET_CYBERSECURITY_REGISTRATION_START_DATE:
      return { ...state, registration_date__gte: action.payload };
    case MapFilterActionsEnum.SET_CYBERSECURITY_REGISTRATION_END_DATE:
      return { ...state, registration_date__lte: action.payload };
    case MapFilterActionsEnum.CLEAN_CYBERSECURITY_REGISTRATION_START_DATE:
      return { ...state, registration_date__gte: undefined };
    case MapFilterActionsEnum.CLEAN_CYBERSECURITY_REGISTRATION_END_DATE:
      return { ...state, registration_date__lte: undefined };
    case MapFilterActionsEnum.CLEAN_CYBERSECURITY_REGISTRATION_DATE:
      return {
        ...state,
        registration_date__gte: undefined,
        registration_date__lte: undefined,
      };
    case MapFilterActionsEnum.SET_CYBERSECURITY_COMPANY_TYPE:
      return state.company_type.includes(action.payload)
        ? {
            ...state,
            company_type: state.company_type.filter(
              (item) => item !== action.payload
            ),
          }
        : {
            ...state,
            company_type: [...state.company_type, action.payload],
          };
    case MapFilterActionsEnum.CLEAN_CYBERSECURITY_COMPANY_TYPE:
      return { ...state, company_type: [] };
    case MapFilterActionsEnum.SET_CYBERSECURITY_SERVICES:
      return state.services.includes(action.payload)
        ? {
            ...state,
            services: state.services.filter((item) => item !== action.payload),
          }
        : {
            ...state,
            services: [...state.services, action.payload],
          };

    case MapFilterActionsEnum.SET_CYBERSECURITY_OTHER_SERVICES:
      return state.other_services?.includes(action.payload)
        ? {
            ...state,
            other_services: state.other_services?.filter(
              (item) => item !== action.payload
            ),
          }
        : {
            ...state,
            other_services: state.other_services
              ? [...state.other_services, action.payload]
              : [action.payload],
          };

    // return { ...state, other_services: action.payload };

    case MapFilterActionsEnum.CLEAN_CYBERSECURITY_SERVICES:
      return { ...state, services: [] };

    case MapFilterActionsEnum.CLEAN_CYBERSECURITY_OTHER_SERVICES:
      return { ...state, other_services: undefined };
    case MapFilterActionsEnum.SET_CYBERSECURITY_CERTIFICATIONS:
      return { ...state, certifications: action.payload };
    case MapFilterActionsEnum.CLEAN_CYBERSECURITY_CERTIFICATIONS:
      return { ...state, certifications: undefined };
    case MapFilterActionsEnum.SET_CYBERSECURITY_SUGGESTION:
      return { ...state, suggestions: [...action.payload] };
    case MapFilterActionsEnum.SET_CYBERSECURITY_ACTIVE_SUGGESTION:
      const suggestions = [...state.activeSuggestions, action.payload];
      const sudCodes = suggestions.map((item) => item.code);
      const uniqueSudCodes = uniq(sudCodes);
      const uniqSuggestions = uniqueSudCodes.map((item) =>
        suggestions.find((sud) => sud.code === item)
      );
      return { ...state, activeSuggestions: uniqSuggestions };
    case MapFilterActionsEnum.CLEAN_CYBERSECURITY_SUGGESTION:
      return { ...state, activeSuggestions: [] };
    case MapFilterActionsEnum.DELETE_CYBERSECURITY_ACTIVE_SUGGESTION:
      return {
        ...state,
        activeSuggestions: state.activeSuggestions.filter(
          (item) => item !== action.payload
        ),
      };
    default:
      return state;
  }
}
